module.exports = __webpack_public_path__ + "static/media/watch_movie.4d091d28.svg";